export class Seasons {
    constructor(
      public ID: number,
      public Name: string,
      public IsDeleted: boolean,
    ) { }
  }
  